"use strict";

exports.__esModule = true;
exports.Schema = void 0;
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
const Schema = exports.Schema = {
  make: ({
    id = '',
    fields = {}
  } = {}) => ({
    id,
    fields
  }),
  makeField: ({
    type = 'text',
    referencedCollection
  } = {}) => ({
    type,
    referencedCollection
  }),
  getFieldType: (schema, fieldName) => getFieldSchema(schema, fieldName).type,
  getReferencedCollectionIds: schema => {
    const uniqueIds = Object.entries(schema.fields).reduce((acc, [_, {
      referencedCollection
    }]) => referencedCollection ? acc.add(referencedCollection) : acc, new Set());
    return Array.from(uniqueIds);
  },
  getReferencedCollectionId: (schema, fieldName) => getFieldSchema(schema, fieldName).referencedCollection,
  isFieldOfType: (schema, fieldName, type) => {
    const fieldType = Schema.getFieldType(schema, fieldName);
    return fieldType === _wixDataSchemaTypes.FieldType[type];
  }
};
const getFieldSchema = (schema, fieldName) => schema.fields[fieldName] ?? {};
//# sourceMappingURL=schema.js.map